var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../@assets/styles/app.css";
var FloatingItem = function (props) {
    var color = props.color, name = props.name, icon = props.icon, show = props.show, link = props.link, rest = __rest(props, ["color", "name", "icon", "show", "link"]);
    return show ? (_jsxs("a", __assign({ id: "floating-item-".concat(name.replace(" ", "-")), href: link }, rest, { children: [_jsx("span", __assign({ className: "floating-item-icon", style: { backgroundColor: color } }, { children: icon })), name ? _jsx("span", __assign({ className: "floating-item-label" }, { children: name })) : null] }))) : null;
};
export { FloatingItem };
export default FloatingItem;
